import React from 'react';
import Header from './Header';
import FirstPart from './FirstPart';
import SecondPart from './SecondPart';
import ThirdPart from './ThirdPart';
import FifthPart from './FifthPart';
import ForthPart from './ForthPart';
import FooterComponent from './FooterComponent';

import service from './dataService';


let SC3 = {
    BackgroundImage: "url(./images/Image-1_1.jpg)",
    OverlayText: "You don't need tons of solar panels to save money.",
    Video: "https://www.youtube.com/embed/kDz-cchV6QA",
    MakelloPage: "https://www.makello.com/savings/san-diego-solar-calculator"
}
let EC1 = {
    BackgroundImage: "url(./images/3_EV_models_967x550_pin_to_bottom_1_inch.jpg)",
    OverlayText: "Drive on solar power for 1/3 cost of gas.",
    Video: "https://www.youtube.com/embed/gxnCCkjoVPM",
    MakelloPage: "https://www.makello.com/savings/plug-in-vehicle-calculator"
}



class App extends React.Component {
    constructor(props) {
        super(props);

        let campaign_type = "";
        var view_type = "";
        let campaign = {
            name: "",
            BackgroundImage: "",
            OverlayText: "",
            Video: "",
            MakelloPage: ""
        };


        if (window.location.href.indexOf("campaign") > -1) {
            campaign_type = this.getUrlVars()["campaign"];
        }        
        if(window.location.href.indexOf("view") > -1){
            view_type = this.getUrlVars()["view"];
        }
        
        console.log("Title is: " + document.getElementsByTagName('title')[0].innerHTML);
        var allMetaElements = document.getElementsByTagName('meta');
        var metaIndex = 0;
        //loop through and find the element you want
        for (var i=0; i<allMetaElements.length; i++) { 
          if (allMetaElements[i].getAttribute("name") === "description") { 
              metaIndex = i;
             //no need to continue loop after making changes.
             break;
          } 
        }
        if (window.location.href.indexOf("solar-calculator") > -1 || window.location.href.indexOf("SC3") > -1) {
            campaign_type = 'SC3';
            document.getElementsByTagName('title')[0].innerHTML = "san diego solar calculator";
            allMetaElements[metaIndex].setAttribute('content', "San Diego Solar Calculator"); 
        }
        if (window.location.href.indexOf("vehicle-calculator") > -1 || window.location.href.indexOf("EC1")  > -1) {
            campaign_type = 'EC1';
            document.getElementsByTagName('title')[0].innerHTML  = "plug-in vehicle calculator";
            allMetaElements[metaIndex].setAttribute('content', "Plug-In Vehicle Calculator"); 
        }
        if (window.location.href.indexOf("request-a-quote") > -1 || window.location.href.indexOf("RequestQuote") > -1) {
            view_type = 'RequestQuote';
            document.getElementsByTagName('title')[0].innerHTML  = "request a quote";
            allMetaElements[i].setAttribute('content', "Request A Quote"); 
        }

        console.log("Title is: " + document.getElementsByTagName('title')[0].innerHTML);

        if(view_type === "RequestQuote"){
            service.showForthPart();
        }
        
        if (campaign_type === "EC1") {
            campaign.name = "EC1";
            campaign.BackgroundImage = EC1.BackgroundImage;
            campaign.OverlayText = EC1.OverlayText;
            campaign.Video = EC1.Video;
            campaign.MakelloPage = EC1.MakelloPage;
        }
        else {
            //true for all other cases
            campaign.name = "SC3";
            campaign.BackgroundImage = SC3.BackgroundImage;
            campaign.OverlayText = SC3.OverlayText;
            campaign.Video = SC3.Video;
            campaign.MakelloPage = SC3.MakelloPage;
        }

        this.state = {
            campaign,
            userId: 0,
            resolution: window.innerWidth
        };

        service.onValuesChanged(this.dataCenterDataChange.bind(this));
    }

    // componentDidMount(){
    //     loadReCaptcha("AIzaSyCaYjw4-snatuIFfivcFZFAj6UgoyEAM80");
    //       service.updateReferer();
    // }

    dataCenterDataChange(data) {
        console.log("APP component rerenders");
        // console.log("APP component rerenders", data);
      }

    getUrlVars() {
        var vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });

        return vars;
    }

    render() {
        // var StyleWidth = service.showHeader ? {maxWidth: "100%"} : {};
        return (
            <div className="container">
                <div className="bg-white">
                    <Header video={this.state.campaign.Video}/>
                    <FirstPart campaign={this.state.campaign} />
                    <SecondPart campaign={this.state.campaign} />
                    <ThirdPart />
                    <ForthPart />
                    <FifthPart />
                    <FooterComponent />
                </div>
            </div>
        );
    }
}

export default App;